export const canParseToNumber = (item:any):boolean => {
  if (!item) return false;
  if (!isNaN(Number(item))) return true;
  else return false;
};